import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import CloseIcon from '@material-ui/icons/Close'

import {
  Typography,
  ButtonBase,
  Button,
  Box,
  Theme,
  Paper,
} from '@material-ui/core'
import { FormattedMessage } from 'react-intl'

const useStyles = makeStyles((theme: Theme) => ({
  activeButton: {
    boxShadow: '0 0 8px 0 rgba(15, 105, 175, 0.5)',
    border: `solid 2px ${theme.palette.primary.main}`,
  },
  containerStyle: {
    position: 'absolute',
    padding: '16px 16px 24px',
    backgroundColor: '#fff',
    opacity: 1,
    right: theme.spacing(8),
  },
  topSection: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBlock: '12px 16px',
    fontWeight: 'bold',
  },
  formContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  linkContainer: {
    border: 'solid gray 1px',
    padding: '8px 8px 8px 16px',
    borderRadius: '5px',
    marginRight: '10px',
    height: '40px',
    width: '290px',
    fontSize: theme.typography.pxToRem(16),
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
  activeLinkStyle: {
    backgroundColor: '#bce2ff',
  },
  buttonStyle: {
    width: '87px',
    paddingBlock: '6px',
  },
  headerText: {
    fontWeight: theme.typography.fontWeightBold,
  },
  deleteCloseIcon: {
    fontSize: theme.typography.pxToRem(22),
    cursor: 'pointer',
    fontWeight: theme.typography.fontWeightBold,
  },
}))

const CopyLinkButton = ({ setShareLinkClicked }) => {
  const [copied, setCopied] = useState(false)
  const classes = useStyles()

  const copyLink = () => {
    navigator.clipboard.writeText(
      `${window.location.href}&sharedContent="true"`
    )
    setCopied(true)
  }

  return (
    <Paper elevation={2} className={classes.containerStyle}>
      <Box className={classes.topSection}>
        <Typography className={classes.headerText}>
          <FormattedMessage defaultMessage="Share Kits" id="SHARE_KITS" />
        </Typography>

        <ButtonBase onClick={() => setShareLinkClicked(false)}>
          <CloseIcon className={classes.deleteCloseIcon} />
        </ButtonBase>
      </Box>
      <Box className={classes.formContainer}>
        <input
          className={` ${classes.linkContainer} ${
            copied ? classes.activeLinkStyle : ''
          }`}
          value={`${window.location.href}&sharedContent="true"`}
          readOnly
        />

        <Button
          variant="outlined"
          color="primary"
          onClick={copyLink}
          className={`${classes.buttonStyle} ${
            copied ? classes.activeButton : ''
          }`}
        >
          {copied ? (
            <FormattedMessage defaultMessage="Copied" id="COPIED" />
          ) : (
            <FormattedMessage defaultMessage="Copy Link" id="COPY_LINK" />
          )}
        </Button>
      </Box>
    </Paper>
  )
}

export default CopyLinkButton
